var _g, _g2, _rect, _path, _rect2, _circle, _circle2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomAutomatedProcessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pilc0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#fl0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 22,
    fill: "#053668"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#fl1_g)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 52,
    height: 42,
    rx: 2,
    fill: "#073459"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 52,
    height: 42,
    rx: 2,
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14H56V49C56 50.1046 55.1046 51 54 51H6C4.89543 51 4 50.1046 4 49V14Z",
    fill: "url(#fff00)",
    fillOpacity: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 56,
    y: 13,
    width: 1,
    height: 52,
    transform: "rotate(90 56 13)",
    fill: "#053668"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9H56V14H4V9Z",
    fill: "url(#gr1)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 1,
    fill: "#80E1D6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fl2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6 32C35.6 35.0928 33.0927 37.6 30 37.6C26.9073 37.6 24.4 35.0928 24.4 32C24.4 28.9072 26.9073 26.4 30 26.4C33.0927 26.4 35.6 28.9072 35.6 32ZM32.8 32C32.8 33.5464 31.5465 34.8 30 34.8C28.4535 34.8 27.2 33.5464 27.2 32C27.2 30.4536 28.4535 29.2 30 29.2C31.5465 29.2 32.8 30.4536 32.8 32Z",
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6 32C35.6 35.0928 33.0927 37.6 30 37.6C26.9073 37.6 24.4 35.0928 24.4 32C24.4 28.9072 26.9073 26.4 30 26.4C33.0927 26.4 35.6 28.9072 35.6 32ZM32.8 32C32.8 33.5464 31.5465 34.8 30 34.8C28.4535 34.8 27.2 33.5464 27.2 32C27.2 30.4536 28.4535 29.2 30 29.2C31.5465 29.2 32.8 30.4536 32.8 32Z",
    fill: "url(#gr2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8335 19.3301C27.8708 18.585 28.4857 18 29.2318 18H30.7682C31.5143 18 32.1292 18.585 32.1665 19.3301L32.2125 20.2515C32.2353 20.7075 32.5655 21.0856 33.0053 21.2078C33.8874 21.4529 34.7257 21.8032 35.5058 22.2444C35.9032 22.4692 36.4039 22.4352 36.7424 22.129L37.4276 21.509C37.9808 21.0085 38.8293 21.0296 39.3569 21.5572L40.4433 22.6437C40.9708 23.1712 40.992 24.0197 40.4915 24.5729L39.8714 25.2583C39.5651 25.5967 39.5312 26.0974 39.7559 26.4947C40.197 27.2747 40.5472 28.1128 40.7922 28.9946C40.9145 29.4345 41.2925 29.7646 41.7485 29.7874L42.6699 29.8335C43.415 29.8707 44 30.4857 44 31.2318V32.7682C44 33.5143 43.415 34.1293 42.6699 34.1665L41.7485 34.2126C41.2925 34.2354 40.9145 34.5655 40.7923 35.0054C40.5471 35.8874 40.1968 36.7257 39.7556 37.5057C39.5309 37.9031 39.5648 38.4037 39.8711 38.7422L40.4908 39.4272C40.9913 39.9804 40.9701 40.8289 40.4426 41.3564L39.3562 42.4429C38.8286 42.9704 37.9801 42.9916 37.4269 42.4911L36.7419 41.8713C36.4034 41.565 35.9027 41.5311 35.5053 41.7558C34.7254 42.1969 33.8873 42.5471 33.0054 42.7922C32.5655 42.9144 32.2353 43.2925 32.2125 43.7484L32.1665 44.6699C32.1292 45.415 31.5143 46 30.7682 46H29.2318C28.4857 46 27.8708 45.415 27.8335 44.6699L27.7875 43.7484C27.7647 43.2925 27.4345 42.9144 26.9946 42.7922C26.1127 42.5471 25.2746 42.1969 24.4947 41.7558C24.0973 41.5311 23.5966 41.565 23.2582 41.8713L22.5734 42.4908C22.0202 42.9913 21.1717 42.9701 20.6443 42.4426L19.5578 41.3562C19.0302 40.8287 19.009 39.9801 19.5096 39.4269L20.1289 38.7423C20.4352 38.4038 20.4691 37.9031 20.2444 37.5058C19.8032 36.7257 19.4529 35.8874 19.2077 35.0054C19.0855 34.5655 18.7075 34.2354 18.2515 34.2126L17.3301 34.1665C16.585 34.1293 16 33.5143 16 32.7682V31.2318C16 30.4857 16.585 29.8707 17.3301 29.8335L18.2515 29.7874C18.7075 29.7646 19.0855 29.4345 19.2078 28.9946C19.4529 28.1128 19.8032 27.2747 20.2442 26.4947C20.4689 26.0974 20.435 25.5967 20.1287 25.2582L19.5089 24.5731C19.0085 24.0199 19.0297 23.1714 19.5573 22.6439L20.6437 21.5574C21.1712 21.0299 22.0197 21.0087 22.5729 21.5092L23.2578 22.1289C23.5963 22.4352 24.097 22.4691 24.4943 22.2444C25.2744 21.8032 26.1126 21.4529 26.9947 21.2078C27.4345 21.0856 27.7647 20.7075 27.7875 20.2515L27.8335 19.3301ZM38.4 32C38.4 36.6392 34.6392 40.4 30 40.4C25.3608 40.4 21.6 36.6392 21.6 32C21.6 27.3608 25.3608 23.6 30 23.6C34.6392 23.6 38.4 27.3608 38.4 32Z",
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8335 19.3301C27.8708 18.585 28.4857 18 29.2318 18H30.7682C31.5143 18 32.1292 18.585 32.1665 19.3301L32.2125 20.2515C32.2353 20.7075 32.5655 21.0856 33.0053 21.2078C33.8874 21.4529 34.7257 21.8032 35.5058 22.2444C35.9032 22.4692 36.4039 22.4352 36.7424 22.129L37.4276 21.509C37.9808 21.0085 38.8293 21.0296 39.3569 21.5572L40.4433 22.6437C40.9708 23.1712 40.992 24.0197 40.4915 24.5729L39.8714 25.2583C39.5651 25.5967 39.5312 26.0974 39.7559 26.4947C40.197 27.2747 40.5472 28.1128 40.7922 28.9946C40.9145 29.4345 41.2925 29.7646 41.7485 29.7874L42.6699 29.8335C43.415 29.8707 44 30.4857 44 31.2318V32.7682C44 33.5143 43.415 34.1293 42.6699 34.1665L41.7485 34.2126C41.2925 34.2354 40.9145 34.5655 40.7923 35.0054C40.5471 35.8874 40.1968 36.7257 39.7556 37.5057C39.5309 37.9031 39.5648 38.4037 39.8711 38.7422L40.4908 39.4272C40.9913 39.9804 40.9701 40.8289 40.4426 41.3564L39.3562 42.4429C38.8286 42.9704 37.9801 42.9916 37.4269 42.4911L36.7419 41.8713C36.4034 41.565 35.9027 41.5311 35.5053 41.7558C34.7254 42.1969 33.8873 42.5471 33.0054 42.7922C32.5655 42.9144 32.2353 43.2925 32.2125 43.7484L32.1665 44.6699C32.1292 45.415 31.5143 46 30.7682 46H29.2318C28.4857 46 27.8708 45.415 27.8335 44.6699L27.7875 43.7484C27.7647 43.2925 27.4345 42.9144 26.9946 42.7922C26.1127 42.5471 25.2746 42.1969 24.4947 41.7558C24.0973 41.5311 23.5966 41.565 23.2582 41.8713L22.5734 42.4908C22.0202 42.9913 21.1717 42.9701 20.6443 42.4426L19.5578 41.3562C19.0302 40.8287 19.009 39.9801 19.5096 39.4269L20.1289 38.7423C20.4352 38.4038 20.4691 37.9031 20.2444 37.5058C19.8032 36.7257 19.4529 35.8874 19.2077 35.0054C19.0855 34.5655 18.7075 34.2354 18.2515 34.2126L17.3301 34.1665C16.585 34.1293 16 33.5143 16 32.7682V31.2318C16 30.4857 16.585 29.8707 17.3301 29.8335L18.2515 29.7874C18.7075 29.7646 19.0855 29.4345 19.2078 28.9946C19.4529 28.1128 19.8032 27.2747 20.2442 26.4947C20.4689 26.0974 20.435 25.5967 20.1287 25.2582L19.5089 24.5731C19.0085 24.0199 19.0297 23.1714 19.5573 22.6439L20.6437 21.5574C21.1712 21.0299 22.0197 21.0087 22.5729 21.5092L23.2578 22.1289C23.5963 22.4352 24.097 22.4691 24.4943 22.2444C25.2744 21.8032 26.1126 21.4529 26.9947 21.2078C27.4345 21.0856 27.7647 20.7075 27.7875 20.2515L27.8335 19.3301ZM38.4 32C38.4 36.6392 34.6392 40.4 30 40.4C25.3608 40.4 21.6 36.6392 21.6 32C21.6 27.3608 25.3608 23.6 30 23.6C34.6392 23.6 38.4 27.3608 38.4 32Z",
    fill: "url(#gr3)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fl0",
    x: -16,
    y: -16,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fl1_g",
    x: 2,
    y: 7,
    width: 58,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fl2",
    x: 14.5,
    y: 16.5,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fff00",
    x1: 4,
    y1: 14,
    x2: 57.2376,
    y2: 18.1864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr1",
    x1: 30,
    y1: 9,
    x2: 30,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr2",
    x1: 16.0017,
    y1: 18,
    x2: 36.8507,
    y2: 50.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr3",
    x1: 16.0017,
    y1: 18,
    x2: 36.8507,
    y2: 50.5766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pilc0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAutomatedProcessIcon);
export default __webpack_public_path__ + "static/media/custom-automated-process-icon.143f8a7c.svg";
export { ForwardRef as ReactComponent };